import { PropertyValue } from "src/context/Property/Builder/PropertyBuilder";
import { OnUpdate } from ".";
import { FoodsSelect } from "@foodpilot/foods";
import {
    deserializeOptionsFromProperty,
    serializeOptionsFromProperty,
} from "src/context/Property/PropertyValueSerializer";
import { useState } from "react";

type SelectProps = {
    property: PropertyValue;
    updatePropertyValue: (options: OnUpdate) => void;
    isLocked?: boolean;
};
export const Select = (props: SelectProps) => {
    const { property, updatePropertyValue, isLocked = false } = props;
    const options = property.property.dataList?.options;

    const values = deserializeOptionsFromProperty(property);
    const [selectedValue, setSelectedValue] = useState(values.value);

    return (
        <FoodsSelect
            selectedOption={selectedValue ?? null}
            options={options ?? []}
            onChange={(newValue) => {
                if (newValue !== null) setSelectedValue(newValue);

                const serializedValue = serializeOptionsFromProperty(newValue ?? undefined);
                updatePropertyValue({
                    serializedString: serializedValue.value,
                    dataListOptionIds: serializedValue.dataListOptionIds,
                    calculationType: "action",
                });
            }}
            getId={(option) => option.id}
            getName={(option) => option.label}
            unit={property.unit}
            disabled={isLocked}
            textOptions={{
                placeholder: "",
                searchPlaceholder: "",
                emptyOptionsText: "",
                defaultValueText: undefined,
                noResult: "",
            }}
        />
    );
};
